import { ProfileInterface } from 'store/profile/interfaces'
import { httpMethods } from 'utils/api/client'
import humps from 'humps'

type HttpMethod = 'get' | 'put'

const api = {
  _call: (method: HttpMethod, endpoint: string, params?: any) => {
    const args = params ? humps.decamelizeKeys(params) : null
    return httpMethods[method](endpoint, args)
  },
  updateProfile: (profile: ProfileInterface) => {
    return api._call('put', '/user/profile', profile)
  },
  fetchProfile: () => {
    return api._call('get', '/user/profile')
  },
  updateAcceptedTerms: () => {
    return api._call('put', '/user/profile', { acceptedTerms: true })
  },
}

export default api
